// extracted by mini-css-extract-plugin
export default {"splashscreen":"_Splashscreen_splashscreen__nzmaE","hidden":"_Splashscreen_hidden__LpRGB","logoSvg":"_Splashscreen_logoSvg__cFOEN","title":"_Splashscreen_title__mtmq+"};